import React from "react";
import { Button as MuiButton, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0.5),
  },
  label: {
    textTransform: "none",
  },
  backColor: {
    background: "#1b284b",
  },
}));

export default function Button(props) {
  const { text, size="large", color, variant, onClick, backgroundColor } = props;
  const classes = useStyles();
  

  return (
    <MuiButton
      variant={variant || "contained"}
      size={size}
      color={color || "primary"}
      onClick={onClick}
      className="contact-us-button"
      classes={{ root: classes.root, label: classes.label }}
    >
      {text}
    </MuiButton>
  );
}
